import { AppState } from 'Store'
import { WrappedFormUtilsExtended } from 'Helpers'
import { createSelector, createSelectorCreator, defaultMemoize } from 'reselect'

export const createDeepEqualFormSelector: typeof createSelector = createSelectorCreator(
	defaultMemoize,
	(o1: WrappedFormUtilsExtended, o2: WrappedFormUtilsExtended) => o1 === o2
)
const getGlobalForms = (state: AppState) => state.modules.forms.forms
const getGlobalForm = createSelector(getGlobalForms, (forms) => (key: string) => forms.get(key))
const getGlobalFormMemoized = (key: string) =>
	createDeepEqualFormSelector(
		(state: AppState) => state.modules.forms.forms.get(key),
		(form: WrappedFormUtilsExtended) => form
	)
export const formsSelectors = {
	getGlobalForms,
	getGlobalForm,
	getGlobalFormMemoized,
}
